import * as React from 'react';
import { Container, Dropdown, Form, Button, Modal, Spinner, OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { resolve, reject } from "q";
import { Register as registersevice } from "../../Common/Services/Register";
import { CommentBox } from "../../Common/Components/CommentBox";
import { CommentWithoutList } from "../../Common/Components/CommentWithoutList";
import { Utils } from "../../Common/Utilis";
import { toast } from "react-toastify";

export class DailyActivitySlideOut extends React.Component<any, any> {
    private scrollToBottomlist: any;
    private ChildComment: any;
    private parentScroll: any;
    constructor(props: any) {
        super(props);
        this.scrollToBottomlist = React.createRef();
        this.ChildComment = React.createRef();
        this.parentScroll = React.createRef();
        this.state = {
            formData: {
                id: 1,
                hotelID: -1,
                lettercode: "",
                accountName: "",
                uniqueno: 0,
                date: "",
                accper: "",
                type: "",
                amount: 0,
                description: "",
                vendor: "",
                coa: "",
                coaName: "",
                entryType: "",
                orderNo: 0,
                flag: 1,
                notes: "",
            },
            splitData: [],
            htmlcomment: [],
            canReview: "No",
            canFlag: "No",
            isComment: true,
            reviewCurrentDescription: "",
            reviewStatus: "Flag for Review",
            selectedReviewStatus: "",
            statusTypeList: [
              { id: 1, name: "Flagged for Review", eventName: "Flag for Review" },
              { id: 2, name: "Needs Review", eventName: "Needs Review" },
              { id: 3, name: "Reviewed", eventName: "Reviewed" },
              { id: 4, name: "Review Complete", eventName: "Review Complete" },
            ],
            isReviewed: false,
            showReviewBanner: false,
            showCommentModal: false,
            commentModalTitle: "",
            splitUniqueNos: "",
            isDataLoading: false,
        };
        this.scrollToBottom = this.scrollToBottom.bind(this);
        this.updatedCommentItem = this.updatedCommentItem.bind(this);
    }

    componentDidMount() {
        this.getDepositEntryDetail();
    }

    getDepositEntryDetail = () => {
        this.setState({ isDataLoading: true });
        registersevice.getDepositEntryDetail(this.props?.dailyActivityRequest)
            .then(async (result: any | null) => {
                if (result.length > 0) {
                    let splitUniqueNos = result.filter((data) => data.flag === 2).map(data => data.uniqueno).join();
                    this.setState({ formData: result.filter((data) => data.flag === 1)[0], splitData: result.filter((data) => data.flag === 2), splitUniqueNos, }, () => {
                        this.getReviewPermissions(this.props.hidValue, ""); // API to get review permissions based on bookkeeping subscription
                    });
                } else {
                    this.setState({ isDataLoading: false });
                    Utils.toastError("This transaction has been updated. Please refresh the page to see the updated details.", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    this.props.hideDailyActivitySlideout();
                }
                resolve();
            })
            .catch((error) => {
                this.setState({ isDataLoading: false });
                Utils.toastError("This transaction has been updated. Please refresh the page to see the updated details.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
                this.props.hideDailyActivitySlideout();
                reject();
            });
    }

    getReviewPermissions = (hidValue, type) => {
        let request: any = {};
        request.HotelId = hidValue;
        registersevice
            .GetReviewPermissions(request)
            .then(async (result: any | null) => {
                if (result !== null) {
                    if (result.length > 0) {
                        this.setState(
                            {
                                 canReview: result[0].canReview,
                                 canFlag: result[0].canFlag,
                               // canReview: "No",
                               // canFlag: "No",
                                isComment: false,
                            },
                            () => {
                                this.setState({ isComment: true });
                                this.GetTransactionComment(this.props?.dailyActivityRequest?.uniqueno);
                            }
                        );
                    }
                }
                resolve();
            })
            .catch((error) => {
                Utils.toastError("Something went wrong!", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
                this.setState({ isDataLoading: false });
                reject();
            });
    };

    GetTransactionComment = (uniqueNo) => {
        let statusTypeList: any[] = [
            { id: 1, name: "Flagged for Review", eventName: "Flag for Review" },
            { id: 1, name: "Needs Review", eventName: "Needs Review" },
            { id: 2, name: "Reviewed", eventName: "Reviewed" },
            { id: 3, name: "Review Complete", eventName: "Review Complete" },
        ];

        let commentRequest: any = {};
        commentRequest.uniqueNo = uniqueNo;
        commentRequest.etype = "DailyActivityDeposit";
        commentRequest.depReqDetails = this.state.splitUniqueNos;
        registersevice
            .GetTransactionComment(commentRequest)
            .then(async (result: any | null) => {
                if (result !== null && result.length > 0) {
                    let currentStatus = result[0].currentStatus;
                    let currentStatusUserName = result[0].currentStatusUserName;
                    let reviewCurrentDescription = "";
                    if (currentStatus.length > 0) {
                        let currentFlagName = statusTypeList.filter(
                            (x) => x.eventName.toLowerCase() === currentStatus.toLowerCase()
                        )[0].name;
                        reviewCurrentDescription =
                            currentFlagName + " by " + currentStatusUserName;
                    }

                    this.setState({ htmlcomment: [], isComment: false, isDataLoading: false }, () => {
                        this.setState(
                            {
                                htmlcomment: result,
                                isComment: true,
                                reviewCurrentDescription,
                                reviewStatus: currentStatus,
                                selectedReviewStatus: currentStatus,
                            },
                            () => {
                                this.addReviewStatus();
                            }
                        );
                    });
                } else {
                    this.setState({ isDataLoading: false });
                }
                resolve();
            })
            .catch((error) => {
                Utils.toastError(`Something went wrong! ${error?.message}`, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
                this.setState({ isDataLoading: false });
                reject();
            });
    };

    addReviewComment = (mentionData: any) => {
        let storage = JSON.parse(localStorage.getItem("storage")!);
        let userName = storage.userName;
        let reviewstatus = this.state.reviewStatus;
        let currentFlagName = this.state.statusTypeList.filter(
          (x) => x.eventName.toLowerCase() === reviewstatus.toLowerCase()
        )[0].name;
        let reviewCurrentDescription = currentFlagName + " by " + userName;
    
        // if (reviewstatus.toLowerCase() === "markforreview") {
        //   reviewstatus = "Review";
        // }
        this.ChildComment?.current.addReviewComment(reviewstatus, mentionData);
        this.closeCommentModal(true);
        this.setState({ reviewCurrentDescription }, () => {
          this.addReviewStatus();
          this.ChildComment?.current.addReviewStatus(this.state.reviewStatus);
        });
      };

    addReviewStatus = () => {
        let statusTypeList: any[] = [
            { id: 1, name: "Flagged for Review", eventName: "Flag for Review" },
            { id: 1, name: "Needs Review", eventName: "Needs Review" },
            { id: 2, name: "Reviewed", eventName: "Reviewed" },
            { id: 3, name: "Review Complete", eventName: "Review Complete" },
        ];

        let muniqueno = Number(this.props.dailyActivityRequest.uniqueno);

        let isShowBanner = false;
        let isReview = false;
        if (this.state.reviewStatus.length > 0) {
            isShowBanner = true;
        }
        if (
            (this.state.canReview === "Yes" || this.state.canFlag === "Yes") &&
            (this.state.reviewStatus === "Flag for Review" ||
                this.state.reviewStatus === "Needs Review")
        ) {
            isReview = true;
        }

        if (
            (this.state.canReview === "Yes" || this.state.canFlag === "Yes") &&
            this.state.reviewStatus === "Review Complete" &&
            muniqueno > 0
        ) {
            isShowBanner = false;
            isReview = false;
        }

        let statusList: any[] = [];
        statusTypeList.forEach((element, index) => {
            if (
                element.eventName === "Flag for Review" &&
                this.state.canFlag === "Yes" &&
                (this.state.reviewStatus === "" ||
                    this.state.reviewStatus === "Review Complete")
            ) {
                statusList.push(element);
            }
            if (
                element.eventName === "Needs Review" &&
                this.state.canFlag === "Yes" &&
                this.state.reviewStatus === "Reviewed" &&
                muniqueno > 0
            ) {
                statusList.push(element);
            }
            if (
                element.eventName === "Reviewed" &&
                this.state.canReview === "Yes" &&
                (this.state.reviewStatus === "Flag for Review" ||
                    this.state.reviewStatus === "Needs Review") &&
                muniqueno > 0
            ) {
                statusList.push(element);
            }
            if (
                element.eventName === "Review Complete" &&
                this.state.canFlag === "Yes" &&
                (this.state.reviewStatus === "Flag for Review" ||
                    this.state.reviewStatus === "Needs Review" ||
                    this.state.reviewStatus === "Reviewed") &&
                muniqueno > 0
            ) {
                statusList.push(element);
            }
        });

        this.setState(
            {
                statusTypeList: [],
                showReviewBanner: isShowBanner,
                isReviewed: isReview,
                selectedReviewStatus: this.state.reviewStatus,
            },
            () => {
                this.setState({ statusTypeList: statusList });
            }
        );
    };

    scrollToBottom = () => {
        this.parentScroll.current.scrollTo({
            top: this.parentScroll.current.scrollHeight,
            behavior: "smooth",
        });
    };

    callBackCommentLoad = () => {
        // if (this.props?.loadFrom?.toLowerCase() === "invoicecomments") {
        //     setTimeout(() => {
        //         this.scrollToBottom();
        //     }, 600);
        // }
    };

    updatedCommentItem = () => {
        let updatedItem: any = {};
        // this.setState({ isSave: true });
        updatedItem.transcationDate = this.state.formData.date;
        updatedItem.vendorName = this.state.formData.vendor;
        updatedItem.amountTotal = this.state.formData.amount;
        return updatedItem;
    };

    CommentModalClose = () => {
        // let uniqueno = this.state.formData.uniqueno;
        // this.handleDiscard(uniqueno);
    };

    showbanner = (status) => {
        this.setState({ reviewStatus: status }, () => {
          let storage = JSON.parse(localStorage.getItem("storage")!);
          let userName = storage.userName;
          let reviewstatus = this.state.reviewStatus;
          let currentFlagName = this.state.statusTypeList.filter(
            (x) => x.eventName.toLowerCase() === reviewstatus.toLowerCase()
          )[0].name;
          let reviewCurrentDescription = currentFlagName + " by " + userName;

          let isReview = false;
          if (
            (this.state.canReview === "Yes" || this.state.canFlag === "Yes") &&
            (this.state.reviewStatus === "Flag for Review" ||
              this.state.reviewStatus === "Needs Review")
          ) {
            isReview = true;
          }

          this.setState({ reviewCurrentDescription, isReviewed: isReview }, () => {
            this.addReviewStatus();
          });
        });
    };

    handleReviewStatus = (type) => {
        let commentModalTitle = "";
        switch (type) {
          case "Flag for Review": {
            commentModalTitle = "Flag for Review";
            break;
          }
          case "Needs Review": {
            commentModalTitle = "Change Status to Needs Review";
            break;
          }
          case "Reviewed": {
            commentModalTitle = "Change Status to Reviewed";
            break;
          }
          case "Review Complete": {
            commentModalTitle = "Change Status to Review Complete";
            break;
          }
          default: {
            break;
          }
        }
        this.setState({ commentModalTitle, reviewStatus: type }, () => {
          this.setState({ showCommentModal: true });
        });
      };

      closeCommentModal = (isUpdate) => {
        this.setState({ showCommentModal: false });
      };

    render() {
        const transactionsColumns = [{
            dataField: "lettercode",
            text: "EHID",
            headerClasses: "ehid",
            formatter: (cell: any, row: any, rowIndex: any) => {
                return (
                    <Form.Control
                        type="text"
                        placeholder=""
                        aria-label="Disabled input example"
                        value={row.lettercode}
                        disabled
                        readOnly
                    />
                );
            },
        }, {
            dataField: "coaName",
            text: "COA",
            headerClasses: "coa",
            formatter: (cell: any, row: any, rowIndex: any) => {
                return (
                    <div className='form-control readonly-input-container'>
                        <EllipsisWithTooltip placement="bottom">{row.coaName}</EllipsisWithTooltip>
                    </div>
                );
            },
        }, {
            dataField: "description",
            text: "Description",
            headerClasses: "description",
            formatter: (cell: any, row: any, rowIndex: any) => {
                return (                    
                    <div className='form-control readonly-input-container'>
                        <EllipsisWithTooltip placement="bottom">{row.description}</EllipsisWithTooltip>
                    </div>
                );
            },
        }, {
            dataField: "amount",
            text: "Amount",
            headerClasses: "amount",
            classes: "amount",
            formatter: (cell: any, row: any, rowIndex: any) => {
                return (
                    <Form.Control
                        type="text"
                        placeholder=""
                        aria-label="Disabled input example"
                        value={Utils.currencyFormatWithOutdoller(row.amount)}
                        disabled
                        readOnly
                    />
                );
            },
        }, {
            dataField: "notes",
            text: "",
            headerClasses: "notes",
            formatter: (cell: any, row: any, rowIndex: any) => {
                return (
                    row.notes !== "" ?
                        <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                                <Tooltip id={`notes-info${row}`}>
                                    {row.notes}
                                </Tooltip>
                            }
                        >
                            <div className="notes-icn">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.5556 2.4H11.3889V1H9.94444V2.4H7.05556V1H5.61111V2.4H3.44444C2.64783 2.4 2 3.0279 2 3.8V13.6C2 14.3721 2.64783 15 3.44444 15H13.5556C14.3522 15 15 14.3721 15 13.6V3.8C15 3.0279 14.3522 2.4 13.5556 2.4ZM3.44444 13.6V4.5H5.61111H7.05556H9.94444H11.3889H13.5556V3.8L13.557 13.6H3.44444Z" fill="#6A6E73" />
                                    <path d="M4.66675 6H11.3334V7.33333H4.66675V6ZM4.66675 8.66667H8.00008V10H4.66675V8.66667Z" fill="#6A6E73" />
                                </svg>
                            </div>
                        </OverlayTrigger>
                        : <></>
                );
            },
        }];
        return (
            <div className="transaction-slideout daily-activity pos-fxd index-1000">
                <div className="d-flex">
                    <div className="back-drop  viewer-panel opacity"
                    //onClick={() => this.hideSlideOut()}
                    ></div>
                    <Container fluid className='body-sec viewer-panel' ref={this.parentScroll}>
                        <div className="page-heading pos-sticky underline d-flex">
                            <div className="hid-set d-flex align-items-center">
                                {this.state.formData.lettercode}
                            </div>
                            <div style={{ display: "none" }}>
                                <Button id="btntemp"></Button>
                            </div>
                            <div className="mr-auto align-items-center">
                                <div className="ttl-status d-flex">
                                    <div>Daily Activity Deposit</div>
                                    <div className={"status-tag gray"}>
                                        {this.state.formData.clStatus}
                                    </div>
                                </div>
                            </div>

                            <div className="action-group d-flex">
                                {this.state.statusTypeList.length > 0 && (this.state.canReview === "Yes" || this.state.canFlag === "Yes") &&
                                    <Dropdown
                                        id="btnlist"
                                        className="more-action"
                                        alignRight
                                        onSelect={(e: any) => this.handleReviewStatus(e)}
                                    >
                                        <Dropdown.Toggle
                                            className="btn-outline-primary btn btn-primary more"
                                            id="dropdown-more"
                                        >
                                            <svg
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                                                <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                                                <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                                            </svg>
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu
                                        // className={this.state.isPermission !== "Yes" ? "noChild-item" : ""}
                                        >
                                            {this.state.canFlag === "Yes" &&
                                                (this.state.selectedReviewStatus === "" ||
                                                    this.state.selectedReviewStatus ===
                                                    "Review Complete") && (
                                                    <Dropdown.Item
                                                        eventKey={"Flag for Review"}
                                                        key={"FlagforReview1"}
                                                    >
                                                        {" "}
                                                        {"Flag for Review"}
                                                    </Dropdown.Item>
                                                )}
                                            {this.state.canFlag === "Yes" &&
                                                this.state.selectedReviewStatus === "Reviewed" && (
                                                    <Dropdown.Item
                                                        eventKey={"Needs Review"}
                                                        key={"NeedsReview1"}
                                                    >
                                                        {" "}
                                                        {"Needs Review"}
                                                    </Dropdown.Item>
                                                )}

                                            {this.state.canReview === "Yes" &&
                                                (this.state.selectedReviewStatus ===
                                                    "Flag for Review" ||
                                                    this.state.selectedReviewStatus ===
                                                    "Needs Review") && (
                                                    <Dropdown.Item
                                                        eventKey={"Reviewed"}
                                                        key={"Reviewed1"}
                                                    >
                                                        {" "}
                                                        {"Reviewed"}
                                                    </Dropdown.Item>
                                                )}

                                            {this.state.canFlag === "Yes" &&
                                                (this.state.selectedReviewStatus ===
                                                    "Flag for Review" ||
                                                    this.state.selectedReviewStatus ===
                                                    "Needs Review" ||
                                                    this.state.selectedReviewStatus === "Reviewed") && (
                                                    <Dropdown.Item
                                                        eventKey={"Review Complete"}
                                                        key={"CompleteReview1"}
                                                    >
                                                        {" "}
                                                        {"Review Complete"}
                                                    </Dropdown.Item>
                                                )}

                                        </Dropdown.Menu>
                                    </Dropdown>
                                }
                                <button
                                    type="button"
                                    className="btn wht-bg cross"
                                    onClick={() =>
                                        this.props.hideDailyActivitySlideout()
                                    }
                                >
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"
                                            fill="#84888C"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        {/* Start Banner Section */}

                        <div className="top-banner-sec pos-sticky">
                            {this.state.showReviewBanner && (
                                <div
                                    className={`banner margin d-flex align-items-center ${this.state.isReviewed ? "reviewed orange-bg" : "blue-bg"
                                        }`}
                                >
                                    <div className="flag-icon">
                                        <svg
                                            width="16"
                                            height="18"
                                            viewBox="0 0 16 18"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M9.9 2.5L9.66 1.3C9.57 0.84 9.16 0.5 8.68 0.5H1.5C0.95 0.5 0.5 0.95 0.5 1.5V16.5C0.5 17.05 0.95 17.5 1.5 17.5C2.05 17.5 2.5 17.05 2.5 16.5V10.5H8.1L8.34 11.7C8.43 12.17 8.84 12.5 9.32 12.5H14.5C15.05 12.5 15.5 12.05 15.5 11.5V3.5C15.5 2.95 15.05 2.5 14.5 2.5H9.9Z" />
                                        </svg>
                                    </div>
                                    <div>{this.state.reviewCurrentDescription}</div>
                                    {this.state.statusTypeList.length > 0 && (
                                        <Dropdown className="custom-selectbox ml-auto" alignRight>
                                            <Dropdown.Toggle
                                                id="dropdownStatusList"
                                                className="d-flex align-items-center"
                                            >
                                                <div className="value">
                                                    <EllipsisWithTooltip placement="bottom">
                                                        {" "}
                                                        {"Change Status"}
                                                    </EllipsisWithTooltip>
                                                </div>

                                                <div className="arrow ml-auto">
                                                    <svg
                                                        width="10"
                                                        height="7"
                                                        viewBox="0 0 10 7"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M8.29268 0.29248L5.00001 3.58581L1.70735 0.29248L0.292679 1.70715L5.00001 6.41382L9.70735 1.70715L8.29268 0.29248Z"
                                                            fill="#84888C"
                                                        />
                                                    </svg>
                                                </div>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {this.state.statusTypeList.map(
                                                    (item: any, index: any) => (
                                                        <Dropdown.Item
                                                            className={`d-flex align-items-center ${item.eventName == "Flag for Review" ? "flgForReview" : "" }`}
                                                            key={item.eventName}
                                                            eventKey={item.name}
                                                            onClick={() => this.handleReviewStatus(item.eventName)}
                                                        >
                                                            <EllipsisWithTooltip placement="bottom">
                                                                {item.name}
                                                            </EllipsisWithTooltip>
                                                            {item.eventName == "Flag for Review" && (
                                                                <div className="flag-icon ml-auto">
                                                                    <svg
                                                                        width="16"
                                                                        height="18"
                                                                        viewBox="0 0 16 18"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path d="M9.9 2.5L9.66 1.3C9.57 0.84 9.16 0.5 8.68 0.5H1.5C0.95 0.5 0.5 0.95 0.5 1.5V16.5C0.5 17.05 0.95 17.5 1.5 17.5C2.05 17.5 2.5 17.05 2.5 16.5V10.5H8.1L8.34 11.7C8.43 12.17 8.84 12.5 9.32 12.5H14.5C15.05 12.5 15.5 12.05 15.5 11.5V3.5C15.5 2.95 15.05 2.5 14.5 2.5H9.9Z" />
                                                                    </svg>
                                                                </div>
                                                            )}
                                                        </Dropdown.Item>
                                                    )
                                                )}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    )}
                                </div>
                            )}
                        </div>

                        <div className="filter-sec">
                            <div className='d-flex'>
                                <div className='d-flex flex-wrap mr-auto'>
                                    <Form.Group>
                                        <Form.Label>Type</Form.Label>
                                        <div className='form-control type-width readonly-input-container'>
                                            <EllipsisWithTooltip placement="bottom">{this.state.formData.vendor}</EllipsisWithTooltip>
                                        </div>
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>Account</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder=""
                                            aria-label="Disabled input example"
                                            value={this.state.formData.accountName}
                                            disabled
                                            readOnly
                                        />
                                    </Form.Group>
                                </div>
                                <div className='total-amount inpute'>
                                    <Form.Group>
                                        <Form.Label>Amount</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder=""
                                            aria-label="Disabled input example"
                                            value={Utils.currencyFormat(this.state.formData.amount)}
                                            disabled
                                            readOnly
                                        />
                                    </Form.Group>
                                </div>
                            </div>
                            <div className='d-flex'>
                                <Form.Group>
                                    <Form.Label>Accounting Period</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder=""
                                        aria-label="Disabled input example"
                                        value={this.state.formData.accper}
                                        disabled
                                        readOnly
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>Transaction Date</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder=""
                                        aria-label="Disabled input example"
                                        value={this.state.formData.date}
                                        disabled
                                        readOnly
                                    />
                                </Form.Group>
                            </div>

                        </div>
                        <div className="transactions-list inpute">
                            <BootstrapTable
                                id="tblSplit"
                                keyField="rno"
                                data={this.state.splitData}
                                columns={transactionsColumns}
                            />
                            <div className="d-flex action-btn align-items-center">
                                <div className="total-amount ml-auto" style={{padding: "7px 0px"}}>
                                    Total: {Utils.currencyFormat(this.state.formData.amount)}
                                </div>
                            </div>
                        </div>
                        {(this.state.isComment) && (
                            <CommentBox
                                ref={this.ChildComment}
                                hotelid={this.props.hidValue}
                                entryType={"DailyActivityDeposit"}
                                uniqueNo={this.props.dailyActivityRequest.uniqueno}
                                precommentlist={this.state.htmlcomment}
                                callBackCommentLoad={this.callBackCommentLoad}
                                parentScrollMethod={this.scrollToBottom}
                                updatedCommentItem={this.updatedCommentItem}
                                commentModalClose={this.CommentModalClose}
                                canReview={this.state.canReview}
                                canFlag={this.state.canFlag}
                                showbanner={this.showbanner}
                                currentReviewStatus={this.state.selectedReviewStatus}
                                depReqDetails = {this.props.depReqDetails}
                                splitUniqueNos = {this.state.splitUniqueNos}
                            />
                        )}
                        {this.state.showCommentModal && (
                            <CommentWithoutList
                                hotelid={this.props.hidValue}
                                closeCommentModal={this.closeCommentModal}
                                addReviewComment={this.addReviewComment}
                                title={this.state.commentModalTitle}
                            />
                        )}
                        {this.state.isDataLoading && (
                            <div className="loader-spinner d-flex justify-content-center align-items-center">
                                <Spinner animation="border" variant="success" />
                            </div>
                        )}
                    </Container>
                </div>
            </div>
        );
    }
}